import React from 'react';
import { Modal, Checkbox, Button  } from 'antd';
import coc from './Coc.pdf'
import eula from './EULA.pdf'
import privacy from './privacy.pdf'

class Terms_Conditions extends React.Component {

  state = {
    width: null,
    privacyAccepted: false,
    eulaAccepted: false,
    cocAccepted: false

  }

  checkBtn = () => {
    if (this.props.mode == 'teacher') {
      if (this.state.privacyAccepted && this.state.eulaAccepted) {
        return false
      } else {
        return true
      }
    } else {
      if (this.state.privacyAccepted && this.state.cocAccepted) {
        return false
      } else {
        return true
      }
    }
  }

  render() {
    const t = this.props.t

    return (
      <Modal
        visible={this.props.open}
        footer={null}
        closable={false}
        className={'termsModal'}
        width={600}
      >
        {this.props.mode == 'student' ?
          <h1 style={styles.title}>{t('Please read our Privacy Policy and our Code of Conduct for Students before proceeding')}</h1>
        :
          <h1 style={styles.title}>{t('Please read our Privacy Policy and our End User Licence Agreement (EULA) before proceeding')}</h1>
        }
        {this.props.mode == 'teacher' ?
          <div>
            <Checkbox style={{marginBottom: 40}} checked={this.state.privacyAccepted} onChange={(e) => this.setState({privacyAccepted: e.target.checked})}>{t('I have read the')} <a style={styles.doc} target="_blank" href={privacy}><strong>{('Tracker Apps Privacy Policy')}</strong></a>. {t('I consent to Tracker Apps handling my personal information in accordance with the Privacy Policy including, in particular, section 7 (purpose of collection, use and disclosure), section 9 (disclosure to third parties), section 10 (overseas disclosure) and section 13 (Direct Marketing)')} </Checkbox>
            <Checkbox style={{marginBottom: 40}} checked={this.state.eulaAccepted} onChange={(e) => this.setState({eulaAccepted: e.target.checked})}>{t('I have read the')} <a style={styles.doc} target="_blank" href={eula}><strong>{t('Tracker Apps Skill Tracker End User Licence Agreement (EULA)')}</strong></a> {t('and agree that by using the App or the Web Portal I will be bound by the terms set out in the EULA.')}</Checkbox>
          </div>
        :
          <div>
            <Checkbox style={{marginBottom: 40}} checked={this.state.privacyAccepted} onChange={(e) => this.setState({privacyAccepted: e.target.checked})}>{t('I have read the')} <a style={styles.doc} target="_blank" href={privacy}><strong>{('Tracker Apps Privacy Policy')}</strong></a>. {t('I consent to Tracker Apps handling my personal information in accordance with the Privacy Policy including, in particular, section 7 (purpose of collection, use and disclosure), section 9 (disclosure to third parties), section 10 (overseas disclosure) and section 13 (Direct Marketing)')}</Checkbox>
            <Checkbox style={{marginBottom: 40}} checked={this.state.cocAccepted} onChange={(e) => this.setState({cocAccepted: e.target.checked})}>{t('I have read the')} <a style={styles.doc} target="_blank" href={coc}><strong>{t('Tracker Apps Skill Tracker Code of Conduct for Students (Code of Conduct)')}</strong></a> {t('and agree that by using the App I will be bound by the terms set out in the Code of Conduct.')} </Checkbox>
          </div>
        }
        <div>
          <Button disabled={this.checkBtn()} onClick={() => this.props.acceptTerms()} style={styles.button}>{t('Proceed')}</Button>
        </div>
      </Modal>
    )
  }
}

export default Terms_Conditions;

const styles = {
  title: {
    color: '#006588',
    fontSize: 20,
    fontFamily: 'Arial Rounded MT Bold',
    marginTop: 20,
  },
  button: {
    backgroundColor: '#006588',
    color: 'white',
    border: 'none',
    borderRadius: '20px',
    marginTop: 10,
    marginLeft: 'auto',
    display: 'block'
  },
  doc: {
    textDecoration: 'underline',
  }
}



// WEBPACK FOOTER //
// ./src/components/Terms_Conditions/index.jsx